module.exports = __webpack_public_path__ + "static/media/239-international house.2eff271c.jpg";